// @flow

export const ACTIONS = {
    FEATURES_SET: 'features-set',
    RESET_ALL: 'reset-all'
};



// WEBPACK FOOTER //
// ./src/v5/features/state/constants.js